import { render, staticRenderFns } from "./ItemOrder.vue?vue&type=template&id=447b1641&scoped=true"
import script from "./ItemOrder.vue?vue&type=script&lang=js"
export * from "./ItemOrder.vue?vue&type=script&lang=js"
import style0 from "./ItemOrder.vue?vue&type=style&index=0&id=447b1641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447b1641",
  null
  
)

export default component.exports